import {
  SET_SUPERANNUATION_INFORMATION,
  SET_SELECTED_SUPERANNUATION_INFORMATION,
  SET_SUPERANNUATION_ENTITY_INFORMATION,
  GET_CLIENT_INFORMATION,
  SET_COMPARE_SUPERANNUATIONS_INFO,
  SET_ICE_PROJECTION_MODEL,
  SET_ICE_API_RESPONSE,
  SET_SUPERANNUATION_CHART_MODEL,
  GET_RISK_PROFILE_DATA
} from "../../../helpers/vuex-constants";
import { SuperannuationService } from "../../../services";
import Superannuation from "../../../models/superannuation";

export default {
  setSuperannuationInformation: {
    root: true,
    async handler(context, payload) {
      try {
        if (context.state.superannuationdata && !context.state.superannuationdata[0]) {
        const response =
          await SuperannuationService.getSuperannuationInformation(
            payload.clientId
          );
        const apidata = response.data;
        if (response.status == 200 && apidata.length >= 1) {
          context.commit(
            SET_SUPERANNUATION_INFORMATION,
            Superannuation.setSuperannuationInformation(
              apidata,
              context.rootGetters[GET_CLIENT_INFORMATION],
              context.rootGetters[GET_RISK_PROFILE_DATA]
            )
          );
        } else {
          context.commit(SET_SUPERANNUATION_INFORMATION, []);
        }
      }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async setAllSuperannuationInformation(context, payload) {
    context.commit(SET_SUPERANNUATION_INFORMATION, payload);
  },
  async [SET_SELECTED_SUPERANNUATION_INFORMATION](context, payload) {
    context.commit(SET_SELECTED_SUPERANNUATION_INFORMATION, payload);
  },
  async [SET_COMPARE_SUPERANNUATIONS_INFO](context, payload) {
    context.commit(SET_COMPARE_SUPERANNUATIONS_INFO, payload);
  },
  async setIceProjectionModel(context, payload) {
    context.commit(SET_ICE_PROJECTION_MODEL, payload);
  },
  async setIceApiResponse(context, payload) {
    context.commit(SET_ICE_API_RESPONSE, payload);
  },
  async setSuperannuationDefaultModel(context, payload) {
    if (payload && payload.length > 0) {
      context.commit(SET_SUPERANNUATION_INFORMATION, payload);
    }
    context.commit(
      SET_SUPERANNUATION_ENTITY_INFORMATION,
      Superannuation.setSuperannuationEntityInformation(
        context.rootGetters[GET_CLIENT_INFORMATION]
      )
    );
  },
  async setSuperannuationChartModel(context, payload) {
    context.commit(SET_SUPERANNUATION_CHART_MODEL, payload);
  },
  async setSelectedSuperannuationInformation(context, payload) {
    context.commit(SET_SELECTED_SUPERANNUATION_INFORMATION, payload);
  },
};
